var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filter-container-content" }, [
    _vm.titleFlag === "2"
      ? _c("div", { staticClass: "filter-container-title" }, [
          _vm._v(_vm._s(_vm.$t("home.additionalChargesPrevious"))),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.titleFlag === "3"
      ? _c("div", { staticClass: "filter-container-title" }, [
          _vm._v(_vm._s(_vm.$t("home.additionalChargesCurrent"))),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "filter-container-content" }, [
      _c(
        "div",
        { staticClass: "table-container-new" },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              attrs: {
                data: _vm.form.webFeeItemComs,
                height: _vm.height,
                "default-sort": { prop: "feeItem", order: "ascending" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "feeItem", label: _vm.$t("home.feeItem") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          { class: _vm.inputClass("feeItem" + scope.$index) },
                          [
                            _c("glCargo", {
                              model: {
                                value: scope.row.feeItem,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "feeItem", $$v)
                                },
                                expression: "scope.row.feeItem",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "payModel", label: _vm.$t("home.payModel") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          { class: _vm.inputClass("payModel" + scope.$index) },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { clearable: "" },
                                model: {
                                  value: scope.row.payModel,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "payModel", $$v)
                                  },
                                  expression: "scope.row.payModel",
                                },
                              },
                              _vm._l(_vm.paidTypeList, function (item) {
                                return _c("el-option", {
                                  key: item.codeValue,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.displayValueCn
                                        : item.displayValue,
                                    value: Number(item.codeValue),
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }